<div class="h-full p-6">
  <div class="">

    <!-- Subscription Status -->
    <div *ngIf="user" class="mb-6 rounded-xl p-6 bg-violet-50 dark:bg-violet-900/20 border border-violet-200 dark:border-violet-800">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <!-- Status icon -->
          <div class="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center bg-violet-100 dark:bg-violet-900/40">
            <!-- Active check icon -->
            <svg *ngIf="user.subscribed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 text-violet-600 dark:text-violet-400">
              <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd" />
            </svg>
            <!-- Inactive warning icon -->
            <svg *ngIf="!user.subscribed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 text-violet-600 dark:text-violet-400">
              <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
            </svg>
          </div>
          <div>
            <h3 class="text-sm font-semibold text-violet-600 dark:text-violet-300">
              {{ user.subscribed ? 'Active Subscription' : (user.on_trial ? 'Trial Period' : 'No Active Subscription') }}
            </h3>
            <p class="text-sm text-violet-600 dark:text-violet-400">
              <ng-container *ngIf="user.subscribed">Your subscription is active. You have full access to all features.</ng-container>
              <ng-container *ngIf="!user.subscribed && user.on_trial">You are on a trial period. Subscribe to keep access after your trial ends.</ng-container>
              <ng-container *ngIf="!user.subscribed && !user.on_trial">Subscribe to get full access to all features.</ng-container>
            </p>
          </div>
        </div>
        <button *ngIf="!user.subscribed"
                type="button"
                (click)="manageBillingAccount()"
                class="whitespace-nowrap btn bg-violet-600 text-white text-sm font-medium hover:bg-violet-700 px-4 py-2 rounded-lg">
          Subscribe Now
        </button>
      </div>
    </div>

    <!-- Cards Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">

      <!-- Card 1: Manage Billing Account -->
      <div class="bg-gray-50 dark:bg-secondary-800 rounded-xl p-6 flex flex-col justify-between">
        <div>
          <!-- Icon -->
          <div class="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-100">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6 text-gray-400">
              <path fill-rule="evenodd" d="M7.84 1.804A1 1 0 0 1 8.82 1h2.36a1 1 0 0 1 .98.804l.331 1.652a6.993 6.993 0 0 1 1.929 1.115l1.598-.54a1 1 0 0 1 1.186.447l1.18 2.044a1 1 0 0 1-.205 1.251l-1.267 1.113a7.047 7.047 0 0 1 0 2.228l1.267 1.113a1 1 0 0 1 .206 1.25l-1.18 2.045a1 1 0 0 1-1.187.447l-1.598-.54a6.993 6.993 0 0 1-1.929 1.115l-.33 1.652a1 1 0 0 1-.98.804H8.82a1 1 0 0 1-.98-.804l-.331-1.652a6.993 6.993 0 0 1-1.929-1.115l-1.598.54a1 1 0 0 1-1.186-.447l-1.18-2.044a1 1 0 0 1 .205-1.251l1.267-1.114a7.05 7.05 0 0 1 0-2.227L1.821 7.773a1 1 0 0 1-.206-1.25l1.18-2.045a1 1 0 0 1 1.187-.447l1.598.54A6.992 6.992 0 0 1 7.51 3.456l.33-1.652ZM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd" />
            </svg>
          </div>

          <!-- Title -->
          <h2 class="text-lg font-semibold text-secondary dark:text-white mb-3">
            Manage Your Billing Account
          </h2>

          <!-- Description -->
          <p class="text-gray-600 dark:text-gray-400 mb-6 text-sm">
            Access your Stripe billing portal to view invoices, update payment methods, and manage your subscription details.
          </p>
        </div>

        <!-- Button -->
        <button
          type="button"
          (click)="manageBillingAccount()"
          class="btn btn-blue cursor-pointer lg:w-auto px-6">
          View Details
        </button>
      </div>

      <!-- Card 2: Buy 750 Credits -->
      <div class="bg-gray-50 dark:bg-secondary-800 rounded-xl p-6 flex flex-col justify-between">
        <div>
          <!-- Icon -->
          <div class="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-100">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6 text-gray-400">
              <path d="M15.98 1.804a1 1 0 0 0-1.96 0l-.24 1.192a1 1 0 0 1-.784.785l-1.192.238a1 1 0 0 0 0 1.962l1.192.238a1 1 0 0 1 .785.785l.238 1.192a1 1 0 0 0 1.962 0l.238-1.192a1 1 0 0 1 .785-.785l1.192-.238a1 1 0 0 0 0-1.962l-1.192-.238a1 1 0 0 1-.785-.785l-.238-1.192ZM6.949 5.684a1 1 0 0 0-1.898 0l-.683 2.051a1 1 0 0 1-.633.633l-2.051.683a1 1 0 0 0 0 1.898l2.051.684a1 1 0 0 1 .633.632l.683 2.051a1 1 0 0 0 1.898 0l.683-2.051a1 1 0 0 1 .633-.633l2.051-.683a1 1 0 0 0 0-1.898l-2.051-.683a1 1 0 0 1-.633-.633L6.95 5.684ZM13.949 13.684a1 1 0 0 0-1.898 0l-.184.551a1 1 0 0 1-.632.633l-.551.183a1 1 0 0 0 0 1.898l.551.183a1 1 0 0 1 .633.633l.183.551a1 1 0 0 0 1.898 0l.184-.551a1 1 0 0 1 .632-.633l.551-.183a1 1 0 0 0 0-1.898l-.551-.184a1 1 0 0 1-.633-.632l-.183-.551Z" />
            </svg>
          </div>

          <!-- Title -->
          <h2 class="text-lg font-semibold text-secondary dark:text-white mb-3">
            Buy 750 Credits
          </h2>

          <!-- Description -->
          <p class="text-gray-600 dark:text-gray-400 mb-6 text-sm">
            Perfect for regular users. Get 750 credits to generate reports, analyze profiles, and access premium features.
          </p>

          <!-- Price Badge -->
          <div class="mb-6">
            <span class="inline-block bg-primary/5 dark:bg-blue-900/30 text-primary dark:text-blue-300 text-xs font-semibold px-3 py-2 rounded-full">
              Popular Choice
            </span>
          </div>
        </div>

        <!-- Button -->
        <button
          type="button"
          (click)="buy750Credits()"
          class="btn btn-blue cursor-pointer lg:w-auto px-6">
          Buy Now
        </button>
      </div>

      <!-- Card 3: Buy 1500 Credits -->
      <div class="bg-primary rounded-xl p-6 flex flex-col justify-between">
        <div>
          <!-- Icon -->
          <div class="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6 text-white">
              <path d="M15.98 1.804a1 1 0 0 0-1.96 0l-.24 1.192a1 1 0 0 1-.784.785l-1.192.238a1 1 0 0 0 0 1.962l1.192.238a1 1 0 0 1 .785.785l.238 1.192a1 1 0 0 0 1.962 0l.238-1.192a1 1 0 0 1 .785-.785l1.192-.238a1 1 0 0 0 0-1.962l-1.192-.238a1 1 0 0 1-.785-.785l-.238-1.192ZM6.949 5.684a1 1 0 0 0-1.898 0l-.683 2.051a1 1 0 0 1-.633.633l-2.051.683a1 1 0 0 0 0 1.898l2.051.684a1 1 0 0 1 .633.632l.683 2.051a1 1 0 0 0 1.898 0l.683-2.051a1 1 0 0 1 .633-.633l2.051-.683a1 1 0 0 0 0-1.898l-2.051-.683a1 1 0 0 1-.633-.633L6.95 5.684ZM13.949 13.684a1 1 0 0 0-1.898 0l-.184.551a1 1 0 0 1-.632.633l-.551.183a1 1 0 0 0 0 1.898l.551.183a1 1 0 0 1 .633.633l.183.551a1 1 0 0 0 1.898 0l.184-.551a1 1 0 0 1 .632-.633l.551-.183a1 1 0 0 0 0-1.898l-.551-.184a1 1 0 0 1-.633-.632l-.183-.551Z" />
            </svg>
          </div>

          <!-- Title -->
          <h2 class="text-lg font-semibold text-white mb-3">
            Buy 1500 Credits
          </h2>

          <!-- Description -->
          <p class="text-white/90 mb-6 text-sm">
            Maximum value for power users. Get 1500 credits with the best price per credit ratio for extensive usage.
          </p>

          <!-- Features List -->
          <ul class="space-y-2 mb-6">
            <li class="flex items-center text-white/90 text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 mr-2 flex-shrink-0">
                <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd" />
              </svg>
              Best Price Per Credit
            </li>
            <li class="flex items-center text-white/90 text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 mr-2 flex-shrink-0">
                <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd" />
              </svg>
              Priority Support
            </li>
          </ul>
        </div>

        <!-- Button -->
        <button
          type="button"
          (click)="buy1500Credits()"
          class="btn bg-white text-primary font-medium cursor-pointer lg:w-auto hover:opacity-90 px-6">
          Buy Now
        </button>
      </div>

    </div>

    <!-- Additional Info Section -->
    <div class="mt-6 bg-gray-50 dark:bg-secondary-800 rounded-xl p-6">
      <div class="flex items-start gap-4">
        <div class="flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 relative top-0.5 text-gray-400">
            <path fill-rule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clip-rule="evenodd" />
          </svg>
        </div>
        <div>
          <h3 class="font-semibold text-secondary dark:text-white mb-2">Secure Payment Processing</h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            All transactions are securely processed through Stripe. Your payment information is encrypted and never stored on our servers.
            Credits are automatically added to your account after successful payment.
          </p>
        </div>
      </div>
    </div>

  </div>
</div>
